import { connect } from "react-redux"
import debounce from "lodash.debounce"
import isEqual from "lodash.isequal"

import Immutable from "immutable"
import PropTypes from "prop-types"
import React from "react"
import swal from "sweetalert"

import sheetConstants from "sheets/constants"
// components
import ResponsiveSheet from "sheets/containers/ResponsiveSheet"

import BACKENDERROR from "app/static/frontend/imports/backenderror"
import { swalContents } from "sheets/components/helpTexts"
import { bigSheetConnection } from "sheets/selectors/sheet-selectors"
import * as actionCreators from "sheets/sheet-action-creators"
import sortTypes from "sheets/sort-types"

export class BigSheet extends React.Component {
    constructor(props) {
        super(props)
        this.loadNextInterval = this.loadNextInterval.bind(this)
        this.load = this.load.bind(this)

        // debounce is a higher order function, and needs to be defined in the constructor to work
        this.debouncedLoadTable = debounce((nextProps) => this.load(nextProps), sheetConstants.REQUEST_DEBOUNCE_TIME)
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const conditions = [
            // the searching value was changed
            !isEqual(nextProps.searchingColumnValues, this.props.searchingColumnValues),
            // the sorting column was changed
            nextProps.sortingColumnId !== this.props.sortingColumnId,
            // the sorting direction was changed
            nextProps.sortType !== this.props.sortType,
        ]

        if (conditions.any()) {
            this.debouncedLoadTable(nextProps)
        }
    }
    componentWillUnmount() {
        if (this.networkRequest) {
            this.networkRequest.abort()
            delete this.networkRequest
        }
    }
    // load the sheet with the filtered conditions
    load = async (nextProps = {}) => {
        const sheetId = nextProps.id || this.props.id
        try {
            // if we have a pending request, abort it
            this.abortPendingRequest()
            // if we are given new props, use them
            if (nextProps.id) {
                this.networkRequest = this.props.loadBigSheet(
                    nextProps.id,
                    nextProps.sheetId,
                    nextProps.searchingColumnValues,
                    nextProps.sortingColumnId,
                    nextProps.sortType,
                )
            } else {
                this.networkRequest = this.props.loadBigSheet(
                    this.props.id,
                    this.props.sheetId,
                    this.props.searchingColumnValues,
                    this.props.sortingColumnId,
                    this.props.sortType,
                )
            }
            await this.networkRequest
        } catch (error) {
            this.handleErr(error, sheetId)
            this.props.clearFilterAndSort(this.props.id)
        }
    }
    /**
     * This function handles errors
     * @param {Error} error - an error
     * @returns {undefined} - (no return value)
     */
    handleErr = async (error, sheetId) => {
        this.props.editSheet(this.props.id, { initialSheetRequestLoading: false, loading: false })
        if (error.response.data && error.response.data.custom_error_message) {
            await swal({ ...swalContents.failLoadSheet, text: error.response.data.custom_error_message })
        } else if (error && error.response && error.response.status === 404) {
            await swal({ ...swalContents.failLoadSheet, text: "This sheet does not exist" })
        } else if (error && error.response && error.response.status === 524) {
            // This is a Cloudflare-specific Timeout status code, means the Sheet query is just too darn big
            Raven.captureMessage(
                `Sheets Query Timed Out on sheet ${sheetId} for ${Userdata.organization_id} -  ${Userdata.organization}`,
            )
            // NOTE: runbook="https://quorumanalytics.atlassian.net/wiki/x/OgB4gg"
            const text =
                "Your current row selection or last column selection is too large to process. Please add filters to reduce the amount of data before loading the sheet or " +
                "reach out to us for assistance at support@quorum.us."
            await swal({ ...swalContents.failLoadSheet, text })
        } else {
            await BACKENDERROR(error, swalContents.failLoadSheet)
        }
    }
    // abort the pending request, if it exists
    abortPendingRequest = () => {
        if (this.networkRequest) {
            this.networkRequest.abort()
            delete this.networkRequest
        }
    }
    loadNextInterval = async () => {
        try {
            this.props.loadBigSheetInterval(
                this.props.id,
                this.props.sheetId,
                this.props.searchingColumnValues,
                this.props.sortingColumnId,
                this.props.sortType,
                this.props.rowData.size,
                sheetConstants.TABLE_SCROLL_INTERVAL,
            )
            await this.props.loadBigSheetInterval
        } catch (error) {
            this.handleErr(error)
        }
    }

    render() {
        return <ResponsiveSheet load={this.load} loadNextInterval={this.loadNextInterval} {...this.props} />
    }
}

BigSheet.propTypes = {
    clearFilterAndSort: PropTypes.func.isRequired,
    editSheet: PropTypes.func.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    loadBigSheet: PropTypes.func.isRequired,
    loadBigSheetInterval: PropTypes.func.isRequired,
    rowData: PropTypes.instanceOf(Immutable.List),
    searchingColumnValues: PropTypes.shape({
        columnID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    sheetId: PropTypes.string.isRequired,
    sortingColumnId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sortType: PropTypes.number,
}

BigSheet.defaultProps = {
    searchingColumnValues: {},
    sortType: sortTypes.ASC,
}

export default connect((state, props) => bigSheetConnection(state, props), actionCreators)(BigSheet)
